import React from 'react';
import './App.css';
import Login from './Components/Auth/Login';
import Dashboard from './Components/Dashboard/Dashboard';
import { AuthProvider, useAuth } from './Context/AuthContext';

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="app">
      {!isAuthenticated ? (
        <Login />
      ) : (
        <Dashboard />
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
